module.exports = __webpack_public_path__ + "e1e0933cf7c78f9c1e9a17bdb7ff6757.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/sharing-center/shared-folders/manage/add-note/shared-folder-add-note.html
// module id = 1804
// module chunks = 0